exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".excel-wrapper[data-v-330d59d5]{font-family:Segoe UI,sans-serif}.sheet-tabs[data-v-330d59d5]{margin-bottom:12px}.sheet-tabs button[data-v-330d59d5]{margin-right:6px;padding:6px 12px;border:1px solid #ddd;background:#f4f4f4;cursor:pointer}.sheet-tabs .active[data-v-330d59d5]{background:#0078d7;color:#fff;border-color:#0078d7}.table-scroll[data-v-330d59d5]{overflow-x:auto}.excel-table[data-v-330d59d5]{border-collapse:collapse;width:100%;min-width:600px}.excel-table td[data-v-330d59d5],.excel-table th[data-v-330d59d5]{border:1px solid #ccc;padding:6px 10px;text-align:left;background:#fff}.excel-table th[data-v-330d59d5]{background:#92df69}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-330d59d5","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/childComponent/ExcelViewer.vue
// module id = 1489
// module chunks = 0